// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__1YZ8h","spinner":"Spinner_spinner__kptye","fadeOut":"Spinner_fadeOut__31G6o"};